import * as React from 'react'
import { connect } from 'react-redux'
import { FormAddEdit } from '../../cost-revenue-new/dialog/FormAddEdit'
import CostColumnsData from 'views/job-costing/utils/CostColumnsData'
import { formatDropDown, convertNumbers, updateFooterTotals, originDestinationCols, checkIfSystemType, calculateTotal } from 'views/job-costing/utils/CostAndRevenueHelpers'
import { checkIsValid, findObjById, isFeatureEnabled, mapReasonCodesToOptions, sortElementByKey } from 'utilities/util'
import { InPageDialog } from 'damco-components'
import { NavCountBar } from 'components/cost-revenue/NavCountBar'
import { INickname } from 'reducers/nickname'
import { DialogTableWrapperNew } from './DialogTableWrapperNew'
import { IStore } from 'reducers/index'
import { ICustomerList, IMaterialList } from 'reducers/materialMaster'
import { fetchVendors } from 'actions/vendors'
import { fetchPartners } from 'actions/partners'
import { resetParties } from 'actions/costRevenue'
import { getMaterialMaster, fetchCustomerMaster } from 'actions/materialMaster'
import { ThunkDispatch } from 'redux-thunk'
import { Action } from 'redux'
import { IExportJob, IChargeItem, IEquipments } from 'reducers/cbl/models'
import { ButtonType, Button } from 'components/button'
import { CostAndRevenue } from 'constants/validationMessages'
import { getReasonCodes } from 'actions/mdm'
import { IFeatureToggleModel } from 'reducers/featureToggle/models'
import { FEATURE_TOGGLES } from 'constants/featureToggles'
import { costAndRevErrorMessage } from '../../../views/job-costing/utils/models'
import { currentPageMode } from '../../../constants/customs'
import CostRevColumnsData from 'views/job-costing/utils/CostRevColumnsData'


interface IProps {
    shouldDisplay: boolean;
    readonlyState: boolean;
    data: IChargeItem[];
    partyData: any;
    type: string,
    target: any;
    targetFunctionality: number;
    vendorsData?: any[];
    isDestination: boolean;
    onSave: (data: any, target?: any, lastIndex?: boolean) => void
    onClose: (target: string) => void;
    costAndRevenueId: number;
    isSourceAthena?: boolean;
}
interface IState {
    chargeItemsList: IChargeItem[];
    selectedChargeItem: any,
    currentIndex: number,
    showDialog: boolean,
    errorMessage: string,
    errorList: string[],
    target: string,
    isReq: boolean,
    type: string,
    isExpanded: boolean;
    shouldUpdate: boolean;
    icbReadOnly: boolean;
    dropDownData: {
        chargeItem: any[],
        partyData: any[]
    },
    table: any,
    partyErrorList: string[],
    isAddMoreDisable: boolean,
    isQantityvalidation: boolean
}
interface IMapDispatchToProps {
    getMaterialMaster: () => Promise<void>;
    fetchCustomerMaster: () => Promise<void>;
    fetchPartners: (type: number, valueId: any) => Promise<void>;
    fetchVendors: (country: string, company: string, org: string) => Promise<void>;
    resetParties: () => Promise<void>;
    getReasonCodes: (category: string) => Promise<void>;
}
interface IMapStateToProps {
    nickname: INickname;
    materialMasterList: IMaterialList[];
    customerlMasterList: ICustomerList[];
    vendors: any[];
    partners: any[];
    vendorsError: string | string[];
    partnersError: string | string[];
    reasonCodes: any[];
    featureToggles: IFeatureToggleModel[];
    chargeItemDistributionData: any;
}

interface IProperties extends IProps, IMapDispatchToProps, IMapStateToProps { }
export class _AddEditDialog extends React.Component<IProperties, IState> {
  public selectTable: any = React.createRef()
  public myDialog: React.RefObject<any>
  constructor(props: IProperties) {
    super(props)
    this.state = this.initState()
    this.myDialog = React.createRef()
  }
  public componentDidMount() {
    this.initData()
    this.callFooterUpdate()
    this.setState({
      target: this.props.target,
      type: this.props.type,
      showDialog: false,
      errorMessage: ''
    })
  }
  public componentDidUpdate(nextProps: any, nextState: any) {
    if (this.props.data !== nextProps.data && this.props.data.length > 0) {
      this.initData()
    }
    if (this.props.materialMasterList !== nextProps.materialMasterList && this.props.materialMasterList.length > 0) {
      this.initChargesDropDown()
    }
    if (this.state.table !== nextState.table) {
      this.callFooterUpdate()
    }
    if (((this.props.partnersError !== nextProps.partnersError && this.props.target === CostColumnsData.TYPES.REVENUE)
            || (this.props.vendorsError !== nextProps.vendorsError && this.props.target === CostColumnsData.TYPES.COST))) {
      const err: string = this.props.target === CostColumnsData.TYPES.COST ? CostAndRevenue.Error_Vendors : CostAndRevenue.Error_Partners
      this.setState({
        showDialog: true,
        errorMessage: err
      })
    }
    if (this.state.chargeItemsList !== nextState.chargeItemsList && this.state.chargeItemsList.length > 0) {
      const newData = this.state.chargeItemsList[this.state.currentIndex]
      this.setState({
        selectedChargeItem: newData,
        partyErrorList: []
      })
      // this.verifyChildren(newData)
      this.callFooterUpdate()
      this.initChargesDropDown()
      this.initPartyData()
    }
    if (this.state.showDialog !== nextState.showDialog && this.state.showDialog) {
      window.scrollTo(0, 0)
    }
  }
  public componentWillUnmount() {
    this.setState(this.initState())
    this.props.resetParties()
  }
  public initState = () => {
    return {
      chargeItemsList: [],
      selectedChargeItem: {},
      currentIndex: -1,
      showDialog: false,
      errorMessage: '',
      errorList: [],
      target: '',
      type: '',
      shouldUpdate: false,
      isExpanded: false,
      table: {},
      isReq: false,
      icbReadOnly: true,
      dropDownData: {
        chargeItem: [],
        partyData: []
      },
      partyErrorList: [],
      isAddMoreDisable: false,
      isQantityvalidation: false
    }
  }
  public initData = () => {
    if (this.props.type === currentPageMode.edit) {
      const category = this.props.isDestination ? 'ISSO' : 'ESSO'
      this.props.getReasonCodes(category)
    }
    if (this.props.materialMasterList.length === 0) {
      this.props.getMaterialMaster()
    } else {
      this.initChargesDropDown()
    }
    const newData = JSON.parse(JSON.stringify(this.props.data))
    if (this.props.type === currentPageMode.add) {
      newData[0].children = []
      newData[0].delete = 'Remove'
    }
    this.setState({
      chargeItemsList: newData,
      currentIndex: 0,
      selectedChargeItem: { ...newData[0] },
      target: this.props.target,
      type: this.props.type
    })
    this.initPartyData()
  }
  public showTable = (): any[] => {
    return this.props.targetFunctionality === 3 ? CostRevColumnsData.getCBLCostRevenueColumn([], false, false, this.props.type === currentPageMode.add ? true: false)
      : originDestinationCols(this.props.isDestination, this.props.target)
  }
  public deleteChargeItem = (item: IChargeItem) => {
    const newData = [...this.state.chargeItemsList.filter((el: IChargeItem) => el.id !== item.id)]
    if(newData.length > 0 && newData.length <= 10) {
      this.setState({
        chargeItemsList: [...newData],
        selectedChargeItem: newData[0],
        currentIndex: 0,
        isAddMoreDisable: false
      })
    } else {
      this.onClose()
    }
  }

  public render() {
    const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
    const isPassThroughEnabled = isFeatureEnabled(FEATURE_TOGGLES.ENABLE_PASSTHROUGH, this.props.featureToggles);
    return (
      <div>
        <div className="grid-wrapper">
          <h2 className="col-70">{this.getTitle()}</h2>
          {this.getButtons()}
        </div>
        <InPageDialog
          showDialog={this.state.showDialog}
          type={'error'}
          message={this.state.errorMessage}
          closeMethod={this.closeDialog} />
        <NavCountBar
          currentIndex={this.state.currentIndex + 1}
          totalIndex={this.state.chargeItemsList.length}
          onClick={this.nextPrevClick} />
        <div ref={this.myDialog}>
          {this.props.shouldDisplay && this.state.currentIndex !== -1 && this.state.dropDownData && this.state.dropDownData.chargeItem.length > 0 &&
                        <FormAddEdit
                          targetFunctionality={this.props.targetFunctionality}
                          data={this.state.selectedChargeItem}
                          readonlyState={this.props.readonlyState}
                          icbReadonlyState={this.state.icbReadOnly}
                          type={this.state.type}
                          target={this.state.target}
                          dropDownData={this.state.dropDownData}
                          errorList={this.state.errorList}
                          onUpdate={this.onUpdate}
                          onClose={this.onClose}
                          reasonCodes={this.props.reasonCodes && mapReasonCodesToOptions(this.props.reasonCodes)}
                          hasSplit={true}
                          onAddMore={this.onAddClick}
                          displayError={this.state.showDialog && this.props.target === CostColumnsData.TYPES.REVENUE ? true : false}
                          onPartyCheckboxToggle={(status:boolean)=>this.onPartyCheckboxToggle(status)}
                          addMoreDisable={this.state.isAddMoreDisable}
                          isQantityError = {this.state.isQantityvalidation}
                          showPassThrough={isPassThroughEnabled}
                          isSourceAthena={this.props.isSourceAthena}
                        />}
          {this.state.chargeItemsList && this.props.shouldDisplay &&
                        <DialogTableWrapperNew
                          data={[...this.state.chargeItemsList]}
                          columns={this.showTable()}
                          subColumns={this.state.selectedChargeItem.children}
                          targetFunctionality={this.props.targetFunctionality}
                          displayDistribution={this.state.selectedChargeItem.displayDistribution}
                          distribution={this.state.selectedChargeItem.distribution}
                          showSub={this.state.isExpanded}
                          target={this.state.target}
                          type={this.props.type}
                          index={this.state.currentIndex}
                          setCurrentIndex={this.onTargetClick}
                          isSelectable={true}
                          fetchData={this.tableOrderFetch}
                          quantity={this.state.selectedChargeItem.quantity}
                          onSelectCallBack={(e: any, data: any) => this.selectAllChildren(e, data)}
                          returnRef={(e: any) => this.setState({ table: e })}
                          isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                          closeMethod={this.closeDialog}
                          deleteCharge = {this.deleteChargeItem}
                          partyComponentErrorList={this.state.partyErrorList}
                          partyComponentTarget={this.state.target}
                          costAndRevenueId={this.props.costAndRevenueId}
                          updateChargeItems={(data:any, idx:number) => this.updateChargeItems(data, idx)}
                          partyCheckboxStatus={this.state.selectedChargeItem.isSameParty}
                          updateKeyInExportJob={(exportJobIdx: number, key:string, value:any)=>this.updateKeyInExportJob(exportJobIdx, key, value)}
                          updateDistributionSplitSelection={(status:boolean)=>this.updateChildrenStatus(status)}
                        />}
        </div>
        <div>
          {this.getButtons()}
        </div>
      </div>
    )
  }

  public updateChildrenStatus = (status:boolean) =>{
    const addCostRev = [...this.state.chargeItemsList]
    const selectedChargeItem = addCostRev[this.state.currentIndex]
    selectedChargeItem.updateChildrenStatus = status
  }
  public onPartyCheckboxToggle = (status:boolean) =>{
    const addCostRev = [...this.state.chargeItemsList]
    const selectedChargeItem = addCostRev[this.state.currentIndex]
    selectedChargeItem.isSameParty = status
    if(!status){
      selectedChargeItem.party = ''
      selectedChargeItem.partyDetails = ''
      selectedChargeItem.icbIndicator = '-'
      selectedChargeItem.isOthers = false
    }

    this.setState({
      selectedChargeItem
    })
  }
  public updateChargeItems = (data:any, idx: number) => {
    const copyChargeItemsList = [...this.state.chargeItemsList]
    const selectedChargeItem = copyChargeItemsList[idx]
    if(!selectedChargeItem.children || selectedChargeItem.children.length === 0){
      selectedChargeItem.children = data
      this.setState({
        chargeItemsList: copyChargeItemsList
      })
    }
    if(!selectedChargeItem.children || selectedChargeItem.children.length === 0){
      this.setState({
        showDialog: true,
        errorMessage: costAndRevErrorMessage.noExportJobAvailable,
      })
    }
  }
  public updateKeyInExportJob = (exportJobIdx:number, key:string, value:any) => {
    let copyChargeItemsList = [...this.state.chargeItemsList]
    const selectedChargeItem = copyChargeItemsList[this.state.currentIndex]
    const exportJob = selectedChargeItem.children ? selectedChargeItem.children[exportJobIdx]: {}
    exportJob[key] = value

    if (this.props.type === currentPageMode.add) {
      copyChargeItemsList = this.shouldDisplayDist(copyChargeItemsList)
    }
    this.setState({
      chargeItemsList: copyChargeItemsList,
      selectedChargeItem: copyChargeItemsList[this.state.currentIndex]
    })
    if(key === 'party' && exportJob[key] && !selectedChargeItem.isSameParty){
      const prevErrorList = this.state.partyErrorList
      prevErrorList[exportJobIdx] = ''
      this.setState({
        partyErrorList: prevErrorList
      })
    }
  }

  public tableOrderFetch = (target: any, tableData: any) => {
    if (tableData.state.sorted && tableData.state.sorted[0]) {
      const tData: any = this.state.chargeItemsList
      const dataType = tableData.sorted && tableData.sorted[0] ? this.showTable().find((column: any) => column.accessor === tableData.sorted[0].id)?.dataType : ''
      this.setState({ chargeItemsList: sortElementByKey(tData, tableData.state.sorted[0].id, tableData.state.sorted[0].desc, dataType) })
    }
  }
  public closeDialog = () => this.setState({ showDialog: false, errorMessage: '' })

  public getButtons = () => {
    return <nav className="col-30 align-text-right">
      <Button
        type="button"
        id="btn-save"
        isDisabled={this.isSaveDisabled()}
        onClick={(e: any) => { e.preventDefault(); this.submitData() }}
        buttonType={ButtonType.Blue}>
                Save
      </Button>&nbsp;
      <Button
        type="button"
        id="btn-cancel"
        onClick={(e: any) => { e.preventDefault(); this.onClose() }}
        buttonType={ButtonType.Transparent}>
                Cancel
      </Button>
    </nav>
  }
  public isSaveDisabled = () => {
    return this.state.chargeItemsList.some((obj:IChargeItem)=> !obj.children || obj.children.length === 0)
  }
  public initPartyData = () => {
    // check for cost
    if (this.props.target === CostColumnsData.TYPES.COST && !this.state.isReq && this.props.shouldDisplay) {
      const country = this.props.partyData.country ? this.props.partyData.country : 'ZZ'
      if (country) {
        this.props.fetchVendors(country, this.props.partyData.company, this.props.partyData.purchase)
        this.setState({
          isReq: true,
          icbReadOnly: true
        })
      } else {
        this.setState({
          showDialog: true,
          errorMessage: CostAndRevenue.Error_Vendors_Country
        })
      }
    }
    // check for revenue
    else if (this.props.target === CostColumnsData.TYPES.REVENUE && !this.state.isReq && this.props.shouldDisplay) {
      this.props.fetchCustomerMaster()
      this.setState({
        isReq: true
      }, () => {
        setTimeout(() => {
          if (this.props.vendorsData && this.props.vendorsData.length > 0) {
            this.props.fetchPartners(this.props.vendorsData[0], this.props.vendorsData[1])
          }
        }, 100)
      })
    }
  }
  public verifyChildren = (data: IChargeItem = this.state.selectedChargeItem) => {
    const resp: any[] = []
    data.children.forEach((obj:IExportJob) =>{
      obj.splits.map((el: IEquipments) => {
        resp.push(el.quantity)
      })
    })
    return resp
  }
  public selectAllChildren = (e: any[], newData:any) => {
    newData[this.state.currentIndex] = this.calculateDistribution(newData[this.state.currentIndex])
    this.setState({
      chargeItemsList: newData,
      selectedChargeItem: newData[this.state.currentIndex]
    })
  }
  public getTitle = (): string => {
    const _data = [...this.props.data]
    const str_last = (this.props.type && this.props.type === currentPageMode.edit && this.state.chargeItemsList && this.state.chargeItemsList.length > 0)
      ? `item # ${_data[this.state.currentIndex].id}` : 'Charge Item'
    const str = `${this.props.type} ${str_last}`
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
  public persistTotals = (currSelectedIndex: IChargeItem) => {
    currSelectedIndex = convertNumbers(currSelectedIndex)
    currSelectedIndex.total = calculateTotal(false, currSelectedIndex)
    currSelectedIndex.totalLocalCurrency = calculateTotal(true, currSelectedIndex)
    this.callFooterUpdate()
    return currSelectedIndex
  }
  public callFooterUpdate = () => {
    if (this.myDialog.current) {
      updateFooterTotals(this.myDialog.current, [...this.state.chargeItemsList], '.BookingDialogTable')
    }
  }
  public initChargesDropDown = () => {
    const chargeItem: any = formatDropDown(this.props.materialMasterList, ['materialNo', 'name'], 'materialNo')
    const oldConfig: any = { ...this.state.dropDownData }
    oldConfig.chargeItem = chargeItem
    this.setState({
      dropDownData: oldConfig
    })
  }
  public onUpdate = (key: any, value: any) => {
    let copyChargeItemsList = [...this.state.chargeItemsList]
    let newError: any = this.state.errorList
    const indOfKey = newError.indexOf(key)
    if(indOfKey > -1){
      newError = newError.splice(indOfKey,1) // removeFromArray(key, newError)
    }

    if(key === 'passThrough'){
      copyChargeItemsList[this.state.currentIndex].passThrough = value === 1 ? 'Y' : 'N';            
    } else if(key === 'serviceRenderedAt'){
      const serviceRenderedAtMap = {
        1: 'ORIGIN',
        2: 'DESTINATION',
        3: 'FREIGHT',
      };
      copyChargeItemsList[this.state.currentIndex].serviceRenderedAt = serviceRenderedAtMap[value] || null;
    }else{
      copyChargeItemsList[this.state.currentIndex][key] = value
    }

    copyChargeItemsList[this.state.currentIndex] = this.persistTotals(copyChargeItemsList[this.state.currentIndex])
    if (key === 'materialCode' && copyChargeItemsList[this.state.currentIndex].materialCode) {
      this.persistMaterialInfo(copyChargeItemsList[this.state.currentIndex], this.props.materialMasterList)
    }
    if (key === 'displayDistribution' && !value && this.props.type === currentPageMode.edit) {
      copyChargeItemsList[this.state.currentIndex].quantity = this.props.data[this.state.currentIndex].quantity
      copyChargeItemsList[this.state.currentIndex]?.children?.map((obj:IExportJob, idx:number)=>{
        const propData = this.props.chargeItemDistributionData[this.state.currentIndex].distributionData[idx].splits
        obj?.splits?.map((item:IEquipments, index:number)=>{
          item.quantity = propData[index].quantity
        })
      })
    }
    if (key === 'unitOfMeasure' && this.props.type === currentPageMode.add) {
      switch (copyChargeItemsList[this.state.currentIndex].unitOfMeasure) {
      case 'DOC':
      case 'EA':
      case 'H':
        copyChargeItemsList[this.state.currentIndex].distribution = 2
        break
      default:
        copyChargeItemsList[this.state.currentIndex].distribution = 1
      }
    }

    if (copyChargeItemsList[this.state.currentIndex].distribution && !isNaN(copyChargeItemsList[this.state.currentIndex].quantity) && Number(copyChargeItemsList[this.state.currentIndex].quantity) > 0) {
      copyChargeItemsList[this.state.currentIndex] = this.calculateDistribution(copyChargeItemsList[this.state.currentIndex])
    }
    if(key === 'party' || key === 'partyName' || key === 'partyDetails' || key === 'icbIndicator' || key === 'others' || key === 'isOthers'){
      copyChargeItemsList[this.state.currentIndex]?.children?.forEach((obj:IExportJob, idx:number)=>{
        this.updateKeyInExportJob(idx, key, value)
      })
    }
    if (this.props.type === currentPageMode.add) {
      copyChargeItemsList = this.shouldDisplayDist(copyChargeItemsList)
    }
    this.setState({
      errorList: newError,
      chargeItemsList: copyChargeItemsList,
      selectedChargeItem: copyChargeItemsList[this.state.currentIndex]
    })
  }
  public shouldDisplayDist = (data: IChargeItem[]) => {
    const allExportJobHasParty = data[this.state.currentIndex].children.every((obj:IExportJob)=>obj.party)
    if (data[this.state.currentIndex].unitOfMeasure && data[this.state.currentIndex].materialCode &&
            data[this.state.currentIndex].quantity && allExportJobHasParty) {
      data[this.state.currentIndex].displayDistribution = true
    } else {
      data[this.state.currentIndex].displayDistribution = false
    }
    return data
  }
  // Fixed according to new hierarchy
  public calculateDistribution = (currentChargeItem: any) => {
    if (currentChargeItem.displayDistribution) {
      let selectedExportJobCount = 0
      currentChargeItem.children.forEach((exportJob:any, exportJobIndex: number)=>{
        const selectedChargeItems: IChargeItem = { ...this.state.chargeItemsList[this.state.currentIndex] }
        if (exportJob.splits.some((split:IEquipments)=>split.select)) {
          selectedChargeItems.children[exportJobIndex].select = true
        } else {
          selectedChargeItems.children[exportJobIndex].select = false
        }
        const selectedDD = exportJob.splits.filter((child: IEquipments) => child.select === true)
        exportJob.selectedItemsCount = selectedDD.length
        selectedExportJobCount = currentChargeItem.children.filter((child: IExportJob) => child.select === true).length
      })
      if(selectedExportJobCount > 0){
        currentChargeItem.children = this.changeDistribution(currentChargeItem.children, Number(currentChargeItem.quantity), selectedExportJobCount)
        currentChargeItem.children.forEach((exportJob:any)=>{
          if(exportJob.selectedItemsCount > 0){
            exportJob.splits = this.changeDistribution(exportJob.splits, Number(exportJob.quantity), exportJob.selectedItemsCount)
          }
        })
      }
    }
    return currentChargeItem
  }
  public changeDistribution = (items: any[], totalQuantity: number, count: number) => {
    const distributionPerItem = (Number(totalQuantity / count));
    const excludeNo = count - 1
    let subTotal = 0
    items.filter((child: IExportJob | IEquipments) => child.select === false).map(item => item.quantity = 0);
    if (count === 1) {
      items.filter((child: IExportJob | IEquipments) => child.select === true)
        .map((obj: IExportJob | IEquipments)=>{
          obj.quantity = totalQuantity.toFixed(3);
        })
    } else {
      items.filter((child: IExportJob | IEquipments, i: number) => child.select === true && i !== excludeNo)
        .map((obj: IExportJob | IEquipments)=>{
          obj.quantity = distributionPerItem.toFixed(3)
          subTotal += isNaN(Number(obj.quantity)) ? 0 : Number(obj.quantity)
        })
      items[excludeNo].quantity = Number(totalQuantity - subTotal).toFixed(3)
    }
    return items
  }

  public onClose = () => {
    this.props.onClose(this.props.target)
  }
  public onTargetClick = (index: number) => {
    this.setState({
      currentIndex: index,
      selectedChargeItem: { ...this.state.chargeItemsList[index] },
      errorList: [],
      errorMessage: ''
    })
  }
  public nextPrevClick = (direction = 0) => {
    const newIndex = this.state.currentIndex + direction
    this.onTargetClick(newIndex)
  }
  public validateData = () => {
    this.setState({ showDialog: false })
    const currData = { ...this.state.chargeItemsList[this.state.currentIndex] }
    let errorMsg = ''
    const checkValid = this.validateChargeItem(currData, this.state.currentIndex)
    let validReasonCode = true
    let validNewICCode = true
    let hasOneSplitSelected = true

    // check selected charge item has party data in each export job
    if(!currData.isSameParty){
      const showError:any[] = []
      currData.children.forEach((exJob:IExportJob)=>{
        const status = exJob.party ? '' : 'party'
        showError.push(status)
      })
      this.setState({partyErrorList: showError})
    }
    if (this.props.type === currentPageMode.edit) {
      errorMsg = (this.props.target === CostColumnsData.TYPES.REVENUE) ? costAndRevErrorMessage.errorMsgRev : costAndRevErrorMessage.errorMsgCost
      // check current selected charge item has at least one split selected in every export job
      hasOneSplitSelected = checkValid.invalidKeys.indexOf('essoRateSplit') === -1

      // check current selected charge item for icbIndicator in every export job
      validNewICCode = checkValid.invalidKeys.indexOf('icbIndicator') === -1
      if(!validNewICCode) {
        const showError:any[] = []
        currData.children.forEach((exJob:IExportJob, idx:number)=>{
          const status = exJob.party && this.props.chargeItemDistributionData[this.state.currentIndex].distributionData[idx].icbIndicator === exJob.icbIndicator ? '' : 'party'
          showError.push(status)
        })
        this.setState({partyErrorList: showError})
      }

      this.state.chargeItemsList.forEach((item: any) => {
        // check reason code for all charge item
        if (!item.reasonCode && checkIfSystemType([item])) {
          checkValid.invalidKeys.push('reasonCode')
          checkValid.invalidList.push('A reason code must be selected')
          validReasonCode = false
        }
      })
    }
    const validateAll: any = this.state.chargeItemsList && this.state.chargeItemsList.length >= 1 ? this.validateAllData([...this.state.chargeItemsList]) : false
    if (checkValid.isValid && (validateAll && validateAll.totalInvalid === 0) && validReasonCode && hasOneSplitSelected && validNewICCode) {
      this.setState({
        showDialog: false,
        errorMessage: '',
        errorList: [],
        partyErrorList: []
      })
      return checkValid.isValid
    } else {
      let msg = this.state.chargeItemsList.length > 1 ?
        `${validateAll.totalInvalid} Charge item(s) is (are) pending review before saving.`
        : `Please fill all the required fields before saving: ${String(checkValid.invalidList).replace(/,(?=[^\s])/g, ', ')}`
      if (!validReasonCode && this.state.chargeItemsList.length > 1) {
        msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} A reason code must be selected.`
      }
      if (!validNewICCode && this.state.chargeItemsList.length > 1) {
        msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} ${errorMsg}.`
      }
      if(!hasOneSplitSelected && this.state.chargeItemsList.length > 1){
        msg = `${msg} ${checkValid.invalidList.length > 1 ? ',' : ''} ${CostAndRevenue.Error_Review_Distribution} : ${CostAndRevenue.Error_Select_Distribution}`
      }
      this.setState({
        showDialog: true,
        errorMessage: msg,
        errorList: checkValid.invalidKeys
      })
    }
    return false
  }

  // Fixed according to new hierarchy
  public isAtLeastOneSelected = () => {
    const resp: boolean[] = []
    const checkList: boolean[] = []
    this.state.chargeItemsList.forEach((element: IChargeItem) => {
      const isSelected = element.children?.some((obj:IExportJob)=>{
        return obj.splits.some((split:IEquipments)=>split.select)
      })
      checkList.push(this.isCountValid(element))
      resp.push(isSelected)
    })
    if (resp.indexOf(false) === -1 && checkList.indexOf(false) === -1) {
      return true
    }
    else if (checkList.indexOf(false) > -1) {
      const list: any[] = []
      resp.forEach((el: boolean, index: number) => {
        if (!el) {
          return list.push(index + 1)
        }
        return el
      })
      const isBilltoPartyBlank = this.state.chargeItemsList.some(charge => charge.party === '')
      const item = resp.length > 1 ? `items ${String(list).replace(/,(?=[^\s])/g, ', ')}` : `Item ${String(list)}`
      const msg = `Review quantity items: ${item}. ${CostAndRevenue.Error_Quantity_Sum} `
      const msg2 = `${this.props.target === CostColumnsData.TYPES.REVENUE ? 'Bill to Party' : 'Pay to Party'} is missing for one or more charge items.`
      this.setState({
        showDialog: true,
        errorMessage: isBilltoPartyBlank ? msg2 : msg,
        errorList: []
      })
    }
    else {
      const list: any[] = []
      resp.forEach((el: boolean, index: number) => {
        if (!el) {
          return list.push(index + 1)
        }
        return el
      })
      const item = resp.length > 1 ? `items ${String(list).replace(/,(?=[^\s])/g, ', ')}}` : `Item ${String(list)}`
      const msg = `${CostAndRevenue.Error_Review_Distribution} ${item}.${CostAndRevenue.Error_Select_Distribution}`
      this.setState({
        showDialog: true,
        errorMessage: msg,
        errorList: []
      })
    }
    return false
  }
  // Fixed according to new hierarchy
  public isCountValid = (el: any): boolean => {
    let count = 0
    const maxQ = el.quantity
    el.children.map((obj:IExportJob)=>{
        if (obj.select) {
          const newNum = Number(obj.quantity)
          count += isNaN(newNum) ? 0 : newNum
        }
    })
    return Number(Math.round(count)) === Number(Math.round(maxQ))
  }

  public checkTypes = () => {
    if (!this.typeAndSizeCheck(this.state.chargeItemsList, true)) {
      this.setState({
        showDialog: true,
        errorMessage: CostAndRevenue.Error_Multiple_Size_Type
      })
      return false
    } else {
      return true
    }
  }
  public submitData = () => {
    if (this.validateData() && ((this.props.type === currentPageMode.add && this.isAtLeastOneSelected()) || this.props.type === currentPageMode.edit) &&
            ((this.props.type === currentPageMode.add && this.checkTypes()) || this.props.type === currentPageMode.edit)) {
      this.setState({
        showDialog: false,
        errorMessage: ''
      })
      const resp = this.state.chargeItemsList.map((element: IChargeItem) => {
        element.errorReason = element.handleError ? '' : element.errorReason
        element = this.persistMaterialInfo(element, this.props.materialMasterList)
        convertNumbers(element)
        return element
      })
      this.props.onSave(resp, this.props.target, true)
    }
  }
  // Fixed according to new hierarchy
  public onAddClick = () => {
    if (this.state.chargeItemsList.length <= 9) {
      const emtpyData: IChargeItem = JSON.parse(JSON.stringify(this.props.data))[0]
      emtpyData.itemType = this.props.nickname.employeeId
      emtpyData.delete = 'Remove'
      const lastId: any = this.state.chargeItemsList.slice(-1)[0].id
      emtpyData.id = lastId + 1
      const newIndex = this.state.currentIndex + 1
      emtpyData.children = []
      const newData = [...this.state.chargeItemsList, { ...emtpyData }]
      this.setState({
        currentIndex: newIndex,
        selectedChargeItem: { ...emtpyData },
        chargeItemsList: newData
      })
      this.callFooterUpdate()
    } else {
      this.setState({
        isAddMoreDisable: true
      })
    }
  }
  
  public persistMaterialInfo = (element: IChargeItem, materialMasterList: any[]) => {
    const objList: { name: string } = findObjById(element.materialCode, materialMasterList, 'materialNo')
    element.materialDescription = (objList && objList.name) ? objList.name : ''
    return element
  }
  public requiredFields = () => {
    const isPassThroughEnabled = isFeatureEnabled(FEATURE_TOGGLES.ENABLE_PASSTHROUGH, this.props.featureToggles);
    const baseData = [
      { key: 'materialCode', label: 'Charge Item' },
      { key: 'quantity', label: 'QTY', type: 'number' },
      { key: 'unitOfMeasure', label: 'UOM' },
      { key: 'localCurrency', label: 'Currency' },
      { key: 'condCurrency', label: 'Currency' },
      { key: 'rate', label: 'Unit Price', type: 'number' }
    ]
    if (isPassThroughEnabled) {
        baseData.push({ key: 'passThrough', label: 'Pass Through' });
    }
    if(this.props.isSourceAthena){
      baseData.push({ key: 'serviceRenderedAt', label: 'Service Rendered At' });
    }
    return baseData;
  }

  public validateAllData = (data: IChargeItem[]) => {
    const validationList = data.map((elData:IChargeItem, index:number) => {
      return this.validateChargeItem(elData, index)
    })
    const counter = validationList.filter((ind: any) => {
      return ind.isValid === false
    })
    return { totalInvalid: counter.length}
  }

  public validateChargeItem = (elData: IChargeItem, index:number) => {
    const checkValid = checkIsValid(elData, this.requiredFields())
    const isPartyPresent = elData.children.every((exJob:IExportJob)=>{
      return exJob.party
    })
    if(!isPartyPresent){
      let field = 'Bill to party'
      if(this.props.target === CostColumnsData.TYPES.COST){
        field = 'Pay to party'
      }
      checkValid.invalidKeys.push('party')
      checkValid.invalidList.push(field)
      checkValid.isValid = false
    }
    if(elData.quantity > 999999999){
      checkValid.invalidKeys.push('quantity')
        checkValid.invalidList.push(`${costAndRevErrorMessage.errorMsgQuantity}`)
        checkValid.isValid = false
        this.setState({
          isQantityvalidation: false
        })
    }
   else if (elData.unitOfMeasure === 'CNT' || elData.unitOfMeasure === 'DOC' || elData.unitOfMeasure === 'EA' || elData.unitOfMeasure === 'PAL') {
      const quantitySavedata = Number(elData.quantity.toString().split('.')[0])
      if (quantitySavedata > 999) {
        checkValid.invalidKeys.push('quantity')
        checkValid.invalidList.push(`${costAndRevErrorMessage.errorMsgQuantityNew}`)
        checkValid.isValid = false
        this.setState({
          isQantityvalidation: true
        })
      }
    }  else {
      this.setState({
        isQantityvalidation: false
      })
    }

    if(this.props.type === currentPageMode.edit){
      // check every export job has at least one split selected
      const isAtLeastOneSplitSelected = elData.children.every((obj:IExportJob)=>{
        return obj.splits.some((split:IEquipments)=> !(split.select === false) )
      })
      if(!isAtLeastOneSplitSelected){
        checkValid.invalidKeys.push('essoRateSplit')
        checkValid.invalidList.push(`${CostAndRevenue.Error_Review_Distribution} : ${CostAndRevenue.Error_Select_Distribution}`)
        checkValid.isValid = false
      }
      // validate icbIndicator for each export job
      if(this.props.chargeItemDistributionData?.length > 0){
        const isICValid = elData.children.every((exJob:IExportJob, idx:number)=>{
          return (exJob.party && this.props.chargeItemDistributionData[index].distributionData[idx].icbIndicator === exJob.icbIndicator)
        })
        if(!isICValid){
          const errorMsg = (this.props.target === CostColumnsData.TYPES.REVENUE) ? costAndRevErrorMessage.errorMsgRev : costAndRevErrorMessage.errorMsgCost
          checkValid.invalidKeys.push('icbIndicator')
          checkValid.invalidList.push(errorMsg)
          checkValid.isValid = false
        }
      }
    }
    return checkValid
  }

  private typeAndSizeCheck = (data: IChargeItem[], fromDialog = false) => {
    let doesMatch = true
    const arrRep: boolean[] = []
    let containerSize = ''
    let substitutionSize = ''
    if (data && data.length > 0) {
      data.forEach((element: IChargeItem) => {
        const exportJob: IExportJob[] = element.children
        exportJob.forEach((exJob: IExportJob)=>{
          let target: IEquipments[] = exJob.splits
          let internalMatch = true
          if (fromDialog) {
            target = target.filter((item: IEquipments) => item.select)
          }
          target.some((child: IEquipments, childIndex: number) => {
            if (childIndex === 0) {
              containerSize = child.containerSizeType
              substitutionSize = child.substitutionSizeType
            }
            if (child.containerSizeType !== containerSize || child.substitutionSizeType !== substitutionSize) {
              internalMatch = false
            }
            return
          })
          arrRep.push(internalMatch)
        })
      })
      if (arrRep.includes(false)) {
        doesMatch = false
      }
    }
    return doesMatch
  }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
  nickname: state.nickname.userNickName,
  materialMasterList: state.materialMaster.materialMasterList,
  vendors: state.vendors.vendors,
  vendorsError: state.vendors.pendingError,
  partners: state.partners.partners.result,
  partnersError: state.partners.pendingError,
  customerlMasterList: state.materialMaster.customerMasterList,
  reasonCodes: state.mdm.reasonCodes,
  featureToggles: state.featureToggle.featureToggles,
  chargeItemDistributionData: state.newCostRevenue.chargeItemData
})

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
  getMaterialMaster: () => dispatch(getMaterialMaster()),
  fetchPartners: (type: number, valueId: any) => dispatch(fetchPartners(type, valueId)),
  fetchCustomerMaster: () => dispatch(fetchCustomerMaster()),
  fetchVendors: (country: string, company: string, org: string) => dispatch(fetchVendors(country, company, org)),
  resetParties: () => dispatch(resetParties()),
  getReasonCodes: (category: string) => dispatch(getReasonCodes(category))
})
export const AddEditDialogNew = connect<IMapStateToProps, IMapDispatchToProps, unknown, IStore>(mapStateToProps, mapDispatchToProps)(_AddEditDialog)
